import React from 'react';

const CardReceitaCustos = ({ data }) => {
  if (!data) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>
        Nenhum dado disponível
      </div>
    );
  }

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor || 0);
  };

  const clampPercent = (v) => {
    const num = Number(v);
    if (!Number.isFinite(num)) return 0;
    return Math.max(0, Math.min(num, 100));
  };

  const getStatusColor = (status) => {
    return status === 'otimo' ? '#10b981' : '#f59e0b';
  };

  const getStatusText = (status) => {
    return status === 'otimo' ? '✅ Ótimo' : '⚠️ Precisa Melhorar';
  };

  const getStatusColorServicos = (status) => {
    const cores = {
      otimo: '#10b981',     // Verde
      bom: '#3b82f6',       // Azul
      razoavel: '#f59e0b',  // Amarelo
      alerta: '#ef4444'     // Vermelho
    };
    return cores[status] || '#6b7280';
  };

  const getStatusTextServicos = (status) => {
    const textos = {
      otimo: '✅ Ótimo - Distribuindo Lucros!',
      bom: '🟢 Bom - Rumo aos 100%',
      razoavel: '🟡 Razoável - Precisa Melhorar',
      alerta: '🔴 ALERTA - Urgente!'
    };
    return textos[status] || status;
  };

  return (
    <div style={{ padding: '20px' }}>
      {/* Receita Total */}
      <div
        style={{
          marginBottom: '20px',
          padding: '15px',
          backgroundColor: '#f0fdf4',
          borderRadius: '8px',
          border: '2px solid #86efac'
        }}
      >
        <div style={{ fontSize: '14px', color: '#166534', fontWeight: '600' }}>
          💰 Receita Total
        </div>
        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#166534', marginTop: '5px' }}>
          {formatarMoeda(data.receita.total)}
        </div>
        <div style={{ fontSize: '12px', color: '#166534', marginTop: '5px' }}>
          Produtos: {formatarMoeda(data.receita.produtos)} | Serviços: {formatarMoeda(data.receita.servicos)}
        </div>
      </div>

      {/* Custos Totais */}
      <div
        style={{
          marginBottom: '20px',
          padding: '15px',
          backgroundColor: '#fef2f2',
          borderRadius: '8px',
          border: '2px solid #fca5a5'
        }}
      >
        <div style={{ fontSize: '14px', color: '#991b1b', fontWeight: '600' }}>
          📉 Custos Totais
        </div>
        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#991b1b', marginTop: '5px' }}>
          {formatarMoeda(data.custos.total)}
        </div>
        <div style={{ fontSize: '12px', color: '#991b1b', marginTop: '5px' }}>
          Produtos: {formatarMoeda(data.custos.produtos)}
          {data.custos.frete > 0 && ` | Frete: ${formatarMoeda(data.custos.frete)}`}
          {` | Terceiros: ${formatarMoeda(data.custos.terceirizados ?? data.custos.terceiros)}`}
          {data.impostos?.total > 0 && ` | Impostos: ${formatarMoeda(data.impostos.total)}`}
        </div>
      </div>

      {/* Resultado Operacional (Faturado) */}
      <div
        style={{
          marginBottom: '15px',
          padding: '15px',
          backgroundColor: '#eff6ff',
          borderRadius: '8px',
          border: '2px solid #93c5fd'
        }}
      >
        <div style={{ fontSize: '14px', color: '#1e40af', fontWeight: '600' }}>
          💎 Resultado Operacional (Faturado)
        </div>
        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e40af', marginTop: '5px' }}>
          {formatarMoeda(data.lucro.valor)}
        </div>
        <div style={{ fontSize: '12px', color: '#1e40af', marginTop: '5px' }}>
          Produtos: {formatarMoeda(data.lucro.produtos)} | Serviços: {formatarMoeda(data.lucro.servicos)}
        </div>
      </div>

      {/* Resultado Operacional (Após Impostos) */}
      {data.impostos?.total > 0 && (
        <div
          style={{
            marginBottom: '20px',
            padding: '15px',
            backgroundColor: '#f0fdf4',
            borderRadius: '8px',
            border: '2px solid #10b981'
          }}
        >
          <div style={{ fontSize: '14px', color: '#166534', fontWeight: '600' }}>
            💵 Resultado Operacional (Após Impostos)
          </div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#166534', marginTop: '5px' }}>
            {formatarMoeda(data.lucro.liquido)}
          </div>
          <div style={{ fontSize: '12px', color: '#166534', marginTop: '5px' }}>
            Produtos: {formatarMoeda(data.lucro.produtos_liquido)} | Serviços: {formatarMoeda(data.lucro.servicos_liquido)}
          </div>
          <div style={{ fontSize: '11px', color: '#166534', marginTop: '5px', fontStyle: 'italic' }}>
            Impostos descontados: {formatarMoeda(data.impostos.total)}
          </div>
        </div>
      )}

      {/* Margem Operacional */}
      <div
        style={{
          marginBottom: '15px',
          padding: '15px',
          backgroundColor: '#f9fafb',
          borderRadius: '8px',
          border: '1px solid #e5e7eb'
        }}
      >
        <div style={{ fontSize: '14px', color: '#374151', fontWeight: '600' }}>
          📊 Margem Operacional
        </div>
        <div
          style={{
            fontSize: '28px',
            fontWeight: 'bold',
            color: '#6366f1',
            marginTop: '5px'
          }}
        >
          {data.lucro.margem_geral}%
        </div>
        {data.impostos?.total > 0 && (
          <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '5px' }}>
            Após impostos: {data.lucro.margem_liquida}%
          </div>
        )}
      </div>

      {/* Margem Produtos com Indicador */}
      <div
        style={{
          marginBottom: '15px',
          padding: '15px',
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          border: `2px solid ${getStatusColor(data.lucro.status_produtos)}`
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '14px', color: '#374151', fontWeight: '600' }}>
              📦 Margem Produtos
            </div>
            <div
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: getStatusColor(data.lucro.status_produtos),
                marginTop: '5px'
              }}
            >
              {data.lucro.margem_produtos}%
            </div>
          </div>
          <div style={{ fontSize: '18px', color: getStatusColor(data.lucro.status_produtos), fontWeight: '600' }}>
            {getStatusText(data.lucro.status_produtos)}
          </div>
        </div>

        <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '8px', fontStyle: 'italic' }}>
          Meta: ≥ 60% para estar ótimo
        </div>
        <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px', fontStyle: 'italic' }}>
          Base: lucro de produtos já desconta frete
        </div>
      </div>

      {/* Lucro em Serviços com Indicador */}
      <div
        style={{
          padding: '15px',
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          border: `2px solid ${getStatusColorServicos(data.lucro.status_servicos)}`
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '14px', color: '#374151', fontWeight: '600' }}>
              🛠️ Lucro em Serviços
            </div>
            <div
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: getStatusColorServicos(data.lucro.status_servicos),
                marginTop: '5px'
              }}
            >
              {formatarMoeda(data.lucro.servicos)}
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '3px' }}>
              {data.lucro.percentual_meta_servicos}% da meta ({formatarMoeda(data.lucro.meta_servicos)})
            </div>
          </div>

          <div
            style={{
              fontSize: '16px',
              color: getStatusColorServicos(data.lucro.status_servicos),
              fontWeight: '600',
              textAlign: 'right'
            }}
          >
            {getStatusTextServicos(data.lucro.status_servicos)}
          </div>
        </div>

        {/* Barra de Progresso */}
        <div style={{ marginTop: '12px', backgroundColor: '#e5e7eb', borderRadius: '4px', height: '8px' }}>
          <div
            style={{
              width: `${clampPercent(data.lucro.percentual_meta_servicos)}%`,
              backgroundColor: getStatusColorServicos(data.lucro.status_servicos),
              height: '100%',
              borderRadius: '4px',
              transition: 'width 0.3s'
            }}
          />
        </div>

        {/* Distribuição de Lucros */}
        {data.lucro.status_servicos === 'otimo' && (
          <div
            style={{
              marginTop: '10px',
              padding: '10px',
              backgroundColor: '#f0fdf4',
              borderRadius: '6px',
              border: '1px solid #86efac'
            }}
          >
            <div style={{ fontSize: '12px', color: '#166534', fontWeight: '600' }}>
              💰 Distribuição de Lucros: {formatarMoeda(data.lucro.distribuicao_lucros)}
            </div>
          </div>
        )}

        {data.lucro.status_servicos === 'bom' && (
          <div
            style={{
              marginTop: '10px',
              padding: '10px',
              backgroundColor: '#eff6ff',
              borderRadius: '6px',
              border: '1px solid #93c5fd'
            }}
          >
            <div style={{ fontSize: '12px', color: '#1e40af', fontWeight: '600' }}>
              📈 Progresso para distribuição: {data.lucro.distribuicao_lucros}%
            </div>
          </div>
        )}

        <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '8px', fontStyle: 'italic' }}>
          Meta: R$ 47.000 = Distribuição | 60% = Bom | 40% = Razoável
        </div>
      </div>
    </div>
  );
};

export default CardReceitaCustos;
